// import { api_getPhoneQRcode } from '@/api/order'
import {api_appInfo } from '@/api/home'
// api_projectTypeList, 
const config = {
  state: {
    ifUserLogin: false,
    // groupcode: '7205',
    groupcode: process.env.VUE_APP_GROUPCODE || 'M1510134781256515586',
    userInfo: {},
    phoneQRcodeImg: '',
    typeList: [],
    clearSearchFlag: false,
    path: process.env.VUE_APP_APIURL || 'http://192.168.0.200:7800',
    platformSettings: []
  },
  mutations: {
    SET_USER_LOGIN(state, flag) {
      state.ifUserLogin = flag
    },
    SET_USER_INFO(state, data) {
      state.userInfo = data
    },
    SET_PHONE_QRCODE_IMG(state, data) {
      state.phoneQRcodeImg = data
    },
    SET_TYPE_LIST(state, data) {
      state.typeList = data
    },
    SET_CLEAR_SEARCH_FLAG(state, data) {
      state.clearSearchFlag = data
    },
    SET_PLATFORM_SETTINGS(state, data) {
      state.platformSettings = data
    },
  },
  actions: {
    HandleLogin({commit}) {
      commit('SET_USER_LOGIN', true)
    },
    HandleLogout({commit}) {
      commit('SET_USER_LOGIN', false)
    },
    GetIfLogin({commit}) {
      commit('SET_USER_LOGIN', localStorage.getItem('membercode'))
      commit('SET_USER_INFO', localStorage.getItem('userInfo'))
    },
    GetphoneQRcodeImg({commit}) {
      const str = config.state.path+"/static/"+config.state.groupcode + ".png";
      commit('SET_PHONE_QRCODE_IMG', str)
    },
    // GetType({commit}) {
    //   const params = {
    //     groupcode: config.state.groupcode
    //   }
    //   api_projectTypeList(params).then(res => {
    //     if (res.code == '0') {
    //       commit('SET_TYPE_LIST', res.data)
    //     }
    //   })
    // },
    HandleClearSearch({commit}, flag) {
      commit('SET_CLEAR_SEARCH_FLAG', flag)
    },
    GetSetting({commit}) {
      api_appInfo().then(res => {
        if (res.code == '0') {
          commit('SET_PLATFORM_SETTINGS', res.data.platformSettings)
        }
      })
    },
  }
}

export default config